import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// web/src/components/chat/TradeSignalFeed.tsx
// The personalized push feed on the Luna landing — Ares's top trade ideas for
// THIS user, pushed without a chat query. Each card is plain-English (headline
// + rationale + conviction); clicking hands the SAME idea to Ares in chat
// (idea.prompt) to complete the build. Push and pull, one brain, consistent.
import { useEffect, useState } from "react";
import { Zap, Loader2 } from "lucide-react";
import { api } from "../../lib/apiClient";
const STYLE_LABEL = {
    momentum: "Momentum",
    value: "Value",
    growth: "Growth",
    quality: "Quality",
    low_volatility: "Low volatility",
    reversal: "Mean reversion",
};
function conviction(c) {
    if (c >= 0.8)
        return { label: "High conviction", cls: "text-emerald-300 bg-emerald-500/10" };
    if (c >= 0.65)
        return { label: "Solid", cls: "text-sky-300 bg-sky-500/10" };
    return { label: "Speculative", cls: "text-amber-300 bg-amber-500/10" };
}
export function TradeSignalFeed({ onBuild }) {
    const [ideas, setIdeas] = useState(null);
    const [failed, setFailed] = useState(false);
    useEffect(() => {
        let cancelled = false;
        api.feed()
            .then((r) => { if (!cancelled)
            setIdeas(r.ideas); })
            .catch(() => { if (!cancelled)
            setFailed(true); });
        return () => { cancelled = true; };
    }, []);
    if (failed || (ideas !== null && ideas.length === 0)) {
        return (_jsx("div", { className: "w-full max-w-2xl mx-auto text-center text-sm text-slate-500 py-10", children: "No trade signals for you right now \u2014 markets may be quiet, or your constraints filtered everything out. Just ask Luna for an idea." }));
    }
    if (ideas === null) {
        return (_jsxs("div", { className: "w-full max-w-2xl mx-auto flex items-center justify-center gap-2 text-sm text-slate-500 py-8", children: [_jsx(Loader2, { size: 15, className: "animate-spin" }), " Finding your best trade ideas\u2026"] }));
    }
    return (_jsxs("div", { className: "w-full max-w-2xl mx-auto", children: [_jsxs("div", { className: "flex items-baseline justify-between mb-2 px-0.5", children: [_jsx("p", { className: "text-[11px] uppercase tracking-widest text-slate-500", children: "Trade signals for you" }), _jsx("span", { className: "text-[10px] text-slate-600", children: "from Ares \u00B7 refreshes daily" })] }), _jsx("div", { className: "flex flex-col gap-2.5", children: ideas.map((idea) => {
                    const cv = conviction(idea.conviction);
                    return (_jsxs("button", { onClick: () => onBuild(idea.prompt), className: "group text-left bg-slate-900 border border-slate-800/70 rounded-xl p-4 hover:border-slate-700 hover:bg-slate-800/40 transition-colors", children: [_jsxs("div", { className: "flex items-center gap-2 mb-1.5", children: [_jsx("span", { className: "text-sm font-semibold text-slate-100", children: idea.symbol }), _jsx("span", { className: "text-[10px] uppercase tracking-wider text-violet-300/80 border border-violet-400/20 rounded px-1.5 py-0.5", children: STYLE_LABEL[idea.style] ?? idea.style }), _jsx("span", { className: `ml-auto text-[10px] rounded px-1.5 py-0.5 ${cv.cls}`, children: cv.label })] }), _jsx("div", { className: "text-[14px] font-medium text-slate-100", children: idea.headline }), idea.rationale && _jsx("p", { className: "text-[13px] text-slate-400 leading-snug mt-1", children: idea.rationale }), _jsxs("span", { className: "inline-flex items-center gap-1.5 text-[13px] font-medium text-violet-300 group-hover:text-violet-200 mt-2.5", children: [_jsx(Zap, { size: 13 }), " Get Ares's optimal strategy"] })] }, `${idea.symbol}-${idea.style}`));
                }) })] }));
}
